export default "__VITE_ASSET__b391e002__"